export default "__VITE_ASSET__5709995b__"